module.exports = __webpack_public_path__ + "img/9.082113f9.png";